<div
  class="d-flex align-items-center justify-content-between _ltd"
  *ngIf="data.length"
>
  <div>
    <h3>{{ "Limited Time Deals" | translate }}</h3>
  </div>
  <div>
    <a
      routerLink="/category/browse/any-department"
      [queryParams]="{ s: 'any-department', key: 'limited_time_deals' }"
      class="seeMore"
      >{{ "See More" | translate }}</a
    >
  </div>
</div>

<div class="categListing clearfix" *ngIf="data.length">
  <ul class="result-base">
    <li class="product-base" *ngFor="let pro of data; let i = index">
      <a routerLink="/product/{{ pro.slug }}">
        <div style="height: 280px; width: 100%">
          <img
            style="width: 100%; height: 100%; display: block"
            loading="lazy"
            src="{{ pro.featured_image_name }}"
            alt="image"
          />
        </div>
      </a>
    </li>
  </ul>
</div>
